export { default as FlatTab } from './FlatTab';
